(function () {
  // MNR-705: Steuert das Laden des Klaviyo-Onsite-Loaders (klaviyo.js + Stub) über die Einwilligung.
  // - Liegt Klaviyo-Consent (Usercentrics) vor → klaviyo.js SEITENWEIT laden (Tracking/Popups/Forms).
  // - Kein Consent + Seite hat eine Embed-Form → Hinweis + „Einwilligen"-Button (analog octane/typeform),
  //   der den Klaviyo-Consent in Usercentrics setzt (= identisch zum Banner) und dann lädt.
  // - Kein Consent + keine Form → nichts (kein IP-Leak); lädt automatisch, sobald Consent erteilt wird.
  // company_id + Popup-Form-IDs kommen per data-Attribut (pro Umgebung/Markt aufgelöst in klaviyo-consent.liquid).
  const scriptEl = document.currentScript || document.querySelector('script[src*="klaviyo-consent"]');
  const COMPANY_ID = scriptEl && scriptEl.getAttribute('data-company-id');

  if (!COMPANY_ID) return;

  const POPUP_MOBILE = (scriptEl && scriptEl.getAttribute('data-popup-mobile')) || '';
  const POPUP_DESKTOP = (scriptEl && scriptEl.getAttribute('data-popup-desktop')) || '';
  const POPUP_BREAKPOINT = parseInt((scriptEl && scriptEl.getAttribute('data-popup-breakpoint')) || '750', 10);
  const PV_KEY = 'shop_page_views';
  const POPUP_SHOWN_KEY = 'klaviyo_popup_shown';
  // MNR-822: Nach Schließen 30 Tage, nach Anmeldung 365 Tage kein Popup — als Cookie, damit es
  // Browser-Neustart und gelöschten sessionStorage überlebt.
  const POPUP_DISMISSED_COOKIE = 'klaviyo_popup_dismissed';
  const POPUP_CLOSED_DAYS = 30;
  const POPUP_SUBSCRIBED_DAYS = 365;
  // MNR-874: Consent-gated Forms (Footer) stehen in einem <template> und werden erst mit Consent
  // in den DOM gesetzt. Sie zählen nicht als Embed-Form der Seite: kein Hinweis/Button, keine Popup-Sperre.
  const GATED_SELECTOR = '[data-klaviyo-consent-gated]';
  const EMBED_FORM_SELECTOR = '[class*="klaviyo-form-"]:not(' + GATED_SELECTOR + ' *)';

  // sessionStorage kann blockiert sein (Privacy-Modus/Sandbox) — nie ungeschützt zugreifen,
  // sonst würde das ganze Script werfen und klaviyo.js/der Hinweis nie laden.
  function safeGet(key) {
    try { return window.sessionStorage.getItem(key); } catch (e) { return null; }
  }
  function safeSet(key, value) {
    try { window.sessionStorage.setItem(key, value); } catch (e) { /* Storage blockiert — ignorieren */ }
  }

  function getCookie(name) {
    const match = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return match ? match[1] : null;
  }
  function setCookie(name, value, days) {
    // `Secure` nur auf https — auf dem http-Dev-Server (shopify theme dev) würde der Browser das Cookie sonst verwerfen.
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = name + '=' + value + '; max-age=' + days * 86400 + '; path=/; SameSite=Lax' + secure;
  }

  const pageViews = (parseInt(safeGet(PV_KEY) || '0', 10) || 0) + 1;
  safeSet(PV_KEY, String(pageViews));

  let popupTriggered = false;

  function loadKlaviyo() {
    // Nicht doppelt laden: klaviyo.js schon da (z.B. PDP-Loader) oder Tag existiert bereits.
    if (window.klaviyo || document.querySelector('script[src*="static.klaviyo.com/onsite/js"]')) return;

    window._klOnsite = window._klOnsite || [];
    try {
      window.klaviyo = new Proxy({}, { get: function (n, i) { return "push" === i ? function () { var n; (n = window._klOnsite).push.apply(n, arguments) } : function () { for (var n = arguments.length, o = new Array(n), w = 0; w < n; w++) o[w] = arguments[w]; var t = "function" == typeof o[o.length - 1] ? o.pop() : void 0, e = new Promise((function (n) { window._klOnsite.push([i].concat(o, [function (i) { t && t(i), n(i) }])) })); return e } } });
    } catch (n) {
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push = function () { var n; (n = window._klOnsite).push.apply(n, arguments) };
    }

    const script = document.createElement('script');
    script.async = true;
    // Bei Ladefehler (Adblocker/Netz): Tag + Stub entfernen, damit ein späteres UC_CONSENT neu laden kann.
    script.onerror = function () {
      script.remove();
      try { delete window.klaviyo; } catch (e) { window.klaviyo = undefined; }
    };
    script.src = 'https://static.klaviyo.com/onsite/js/' + COMPANY_ID + '/klaviyo.js?company_id=' + COMPANY_ID;
    document.body.appendChild(script);
  }

  function removePlaceholders() {
    document.querySelectorAll('.klaviyo-consent-placeholder').forEach((el) => el.remove());
  }

  // Ein Consent-Widerruf versteckt nichts wieder und lädt nicht neu — er wirkt ab dem nächsten Seitenaufruf.
  function revealGatedForms() {
    document.querySelectorAll(GATED_SELECTOR).forEach((el) => {
      const tpl = el.querySelector('template');
      if (tpl) el.replaceChild(tpl.content.cloneNode(true), tpl);
      el.removeAttribute('hidden');
    });
  }

  // Vor Einwilligung: EINEN Hinweis + „Einwilligen"-Button vor der ersten Embed-Form einsetzen.
  // Nicht anzeigen, wenn klaviyo.js schon geladen ist (z.B. PDP) — dann rendert/hydriert Klaviyo selbst.
  function showConsentPlaceholder() {
    if (window.klaviyo || document.querySelector('script[src*="static.klaviyo.com/onsite/js"]')) return;
    const tpl = document.getElementById('klaviyo-consent-template');
    if (!tpl) return;
    if (document.querySelector('.klaviyo-consent-placeholder')) return;
    const form = document.querySelector(EMBED_FORM_SELECTOR);
    if (!form) return;
    const node = tpl.content.cloneNode(true);
    const btn = node.querySelector('.klaviyo-consent-accept');
    if (btn) btn.addEventListener('click', acceptAndLoad);
    form.parentNode.insertBefore(node, form);
  }

  async function getKlaviyoService() {
    if (typeof UC_UI === 'undefined' || !UC_UI.getServicesBaseInfo) return null;
    try {
      const allServices = await UC_UI.getServicesBaseInfo();
      for (const s of allServices) {
        if ((s.name || '').toLowerCase().includes('klaviyo')) return s;
      }
      return null;
    } catch (e) {
      console.warn('Klaviyo consent: UC_UI.getServicesBaseInfo() failed:', e);
      return null;
    }
  }

  function hasConsent(service) {
    return service && service.consent && service.consent.status === true;
  }

  // Popup custom-getriggert öffnen (Forms in Klaviyo stehen auf „Only on a custom trigger").
  // Nur mit Consent (aus checkConsent), ab der 2. Seite/Session, Desktop-/Mobile-Form je Viewport.
  function maybeOpenPopup() {
    if (popupTriggered) return;
    if (!POPUP_MOBILE && !POPUP_DESKTOP) return;
    if (safeGet(POPUP_SHOWN_KEY)) return;
    if (getCookie(POPUP_DISMISSED_COOKIE)) return;
    if (pageViews < 2) return;
    // Kein Popup, wenn die Seite bereits eine andere Klaviyo-Form (Embed) enthält.
    if (document.querySelector(EMBED_FORM_SELECTOR)) return;
    const isDesktop = window.matchMedia('(min-width: ' + POPUP_BREAKPOINT + 'px)').matches;
    const id = (isDesktop ? POPUP_DESKTOP : POPUP_MOBILE) || POPUP_MOBILE || POPUP_DESKTOP;
    if (!id) return;
    popupTriggered = true;

    // „gezeigt" erst markieren, wenn Klaviyo die Form wirklich öffnet — sonst würde ein
    // fehlgeschlagener Load/Trigger das Popup für die Session unterdrücken, ohne es je zu zeigen.
    // Das Cookie erst bei „close"/„submit": Ein Nutzer, der das Popup nie schließt, soll es beim
    // nächsten Besuch wieder sehen können.
    window.addEventListener('klaviyoForms', function onFormEvent(e) {
      const detail = e && e.detail;
      if (!detail || String(detail.formId) !== String(id)) return;
      if (detail.type === 'open') {
        safeSet(POPUP_SHOWN_KEY, '1');
      } else if (detail.type === 'close') {
        if (!getCookie(POPUP_DISMISSED_COOKIE)) setCookie(POPUP_DISMISSED_COOKIE, 'closed', POPUP_CLOSED_DAYS);
        window.removeEventListener('klaviyoForms', onFormEvent);
      } else if (detail.type === 'submit') {
        setCookie(POPUP_DISMISSED_COOKIE, 'subscribed', POPUP_SUBSCRIBED_DAYS);
        window.removeEventListener('klaviyoForms', onFormEvent);
      }
    });

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', id]);
  }

  // Klick auf „Einwilligen": Klaviyo-Service in Usercentrics zustimmen, persistieren, dann laden.
  async function acceptAndLoad() {
    const service = await getKlaviyoService();
    if (service && typeof UC_UI !== 'undefined' && typeof UC_UI.acceptService === 'function') {
      UC_UI.acceptService(service.id);
      if (window.__ucCmp && window.__ucCmp.saveConsents) {
        await window.__ucCmp.saveConsents();
      }
      // Gated Forms nur, wenn der Consent wirklich in Usercentrics gesetzt wurde.
      revealGatedForms();
    }
    removePlaceholders();
    loadKlaviyo();
  }

  async function checkConsent() {
    const service = await getKlaviyoService();
    if (hasConsent(service)) {
      removePlaceholders();
      revealGatedForms();
      loadKlaviyo();
      maybeOpenPopup();
      return true;
    }
    return false;
  }

  async function init() {
    // Consent vorhanden → seitenweit laden (unabhängig davon, ob eine Form da ist).
    if (await checkConsent()) return;
    // Kein Consent: nur auf Form-Seiten den Hinweis + „Einwilligen"-Button zeigen.
    if (document.querySelector(EMBED_FORM_SELECTOR)) {
      showConsentPlaceholder();
    }
    // Lädt, sobald Consent erteilt wird (Banner oder Inline-Button).
    window.addEventListener('UC_CONSENT', checkConsent);
  }

  if (typeof UC_UI !== 'undefined' && UC_UI.isInitialized && UC_UI.isInitialized()) {
    init();
  } else {
    window.addEventListener('UC_UI_INITIALIZED', init);
  }
})();
